module.exports = __webpack_public_path__ + "img/Consolidated-Statement-of-Profit-or-Loss.b49412ca.jpg";